export default __webpack_public_path__ + "static/media/forgot-password.92f01a1f.svg";